import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {TokenContextProvider} from '@/components/TokenContext';
import Login from '@/Login';
import OffBoarding from '@/pages/OffBoarding.tsx';
import OnBoarding from '@/pages/OnBoarding.tsx';
import SelectProject from '@/pages/SelectProject';
import Layout from './Layout';
import Home from './pages/Home';

const App = (): JSX.Element => {
    return (
        <TokenContextProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <BrowserRouter>
                    <Routes>
                        <Route path='/' element={<Layout />}>
                            <Route
                                index
                                element={
                                    <Login
                                        keepKeys={[
                                            'project',
                                            'jiraBaseUrl',
                                            'webhookId',
                                            'batchSize',
                                            'notBefore',
                                        ]}
                                    >
                                        <Home />
                                    </Login>
                                }
                            />
                            <Route
                                path='pickProject'
                                element={
                                    <Login keepKeys={['jiraBaseUrl']}>
                                        <SelectProject />
                                    </Login>
                                }
                            />
                            <Route
                                path='pullProject'
                                element={
                                    <Login
                                        keepKeys={[
                                            'project',
                                            'jiraBaseUrl',
                                            'webhookId',
                                            'batchSize',
                                            'notBefore',
                                        ]}
                                    >
                                        <Home />
                                    </Login>
                                }
                            />
                            <Route
                                path='onBoarding'
                                element={
                                    <Login
                                        keepKeys={[
                                            'project',
                                            'jiraBaseUrl',
                                            'webhookId',
                                            'batchSize',
                                            'notBefore',
                                        ]}
                                    >
                                        <OnBoarding />
                                    </Login>
                                }
                            />
                            <Route
                                path='offBoarding'
                                element={
                                    <Login
                                        keepKeys={[
                                            'project',
                                            'jiraBaseUrl',
                                            'webhookId',
                                            'batchSize',
                                            'notBefore',
                                        ]}
                                    >
                                        <OffBoarding />
                                    </Login>
                                }
                            />
                            <Route path='*' element={<Home />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </LocalizationProvider>
        </TokenContextProvider>
    );
};

export default App;
